import { ReportableError } from '@amazon/vinyl-util'

export class UnauthorizedError extends ReportableError {
    get [Symbol.toStringTag](): string {
        return 'UnauthorizedError'
    }

    // ReportableError's constructor re-points the prototype to ITS own, so a
    // subclass must restore its prototype after `super()` or `instanceof
    // UnauthorizedError` breaks (matches GqlError / RequestError).
    constructor(message?: string) {
        super(message)
        Object.setPrototypeOf(this, UnauthorizedError.prototype)
    }
}
